<app-card>
  <ng-content select="app-filter-tab-header"></ng-content>
</app-card>
<app-card class="content" [@openClose]="isOpen ? 'open' : 'closed'">
  <ng-content select="[appFilterTabContent]"></ng-content>
</app-card>
